import React from 'react'

const InputTableDefaultAllComponent = () => {
  return (
    <div>InputTableDefaultAllComponent</div>
  )
}

export default InputTableDefaultAllComponent